import { render, staticRenderFns } from "./PintuanItem.vue?vue&type=template&id=35070ce3&scoped=true"
import script from "./PintuanItem.vue?vue&type=script&lang=js"
export * from "./PintuanItem.vue?vue&type=script&lang=js"
import style0 from "./PintuanItem.vue?vue&type=style&index=0&id=35070ce3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35070ce3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35070ce3')) {
      api.createRecord('35070ce3', component.options)
    } else {
      api.reload('35070ce3', component.options)
    }
    module.hot.accept("./PintuanItem.vue?vue&type=template&id=35070ce3&scoped=true", function () {
      api.rerender('35070ce3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinSetting/components/PintuanItem.vue"
export default component.exports